// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slice-container[data-v-3d965def]{width:100%}.slice-container img[data-v-3d965def]{width:100%;vertical-align:top}", ""]);
// Exports
module.exports = exports;
